module.exports = __webpack_public_path__ + "img/blobs-better copy.4f7d18b.jpg";